import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const automezzo: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'descrizioneSoggetto - $descrizioneSede',
      titleForm: 'descrizioneSoggetto - $descrizioneSede',
      idBreadcrumbGroup: 'automezzo',
      allowedAdvancedFilter: false,
      isAdvancedXlsExportAvailable: false,
      breadcrumbCaption: 'Automezzi',
      campoTitle: ['descrizioneSede', 'descrizioneSoggetto', 'targa'],
      service: 'automezzo',
      api: 'Automezzo',
      filterList: '/$idSede',
      filterEditor: '?id=$',
      startTemplate: 'grid',
      helpDoc: 'Automezzi.html',

      idTabRif: [
        {
          key: 'idSede',
          value: 'idSede'
        },
      ],
      queryFilter: [

        {
          key: 'idAutomezzo',
          value: 'id'
        },

        {
          key: 'templateTab',
          value: 'templateTab'
        },

        {
          key: 'isScarrabile',
          value: 'isScarrabile'
        },


      ],
      formType: 'simple',
      masterKey: 'id',
      nCol: 1,
      toolbarSettings: {
        service: 'automezzo',

      }


    }

  },

  {
    itemType: "group", colCount: "3", groupWidth:550, caption: 'Automezzi Autorizzati', groupDataField: 'datiprincipali',
    data: [
     
     
      {
        caption: "Descrizione",
        type: 'campo',
        dataField: "descrizione",
        orderGriglia: 1,
        maxLength:45,
       
        showInColumnChooser: true,
        allowHiding: false,
        nCol:10,
        colSpan:3,
        validation: [{ type: "required", message: "Campo Obbligatorio" }],
      },


      {
        showInColumnChooser: true,
        allowHiding: false,
        orderGriglia: 2,
        type: 'campo',
        maxLength: "10",
        dataField: "targa",
        caption: "Nr. Targa",
        nCol:'custom-43',
        validation: [{ type: "required", message: "Campo Obbligatorio" }],
      },
      {
        orderGriglia: 3,
        showInColumnChooser: false,
        type: 'campo',
        labelWidth:60,
        colVisible: false,
        dataField: "taraKg",
        editorType: 'dxNumberBox',
        dataType: "",
        caption: "Tara Kg",
        maxLength: '6',
        nCol:3,
        format: '####.##',
      },

      {
        orderGriglia: 5, showInColumnChooser: false,
        type: 'campo',
        colVisible: false,
        dataField: "portataKg",
        dataType: "number",
        editorType: 'dxNumberBox',
        caption: "Portata Kg",
        format: '####.##',
        maxLength: '6',
        labelWidth:60,
        nCol:3,
      },

      {
        orderGriglia: 6,
        showInColumnChooser: true,
        allowHiding: false,
        type: 'campoSpecial',
        colVisible: true,
        dataField: "tipoAutomezzo",
        caption: "Tipo",
        hideOnEdit: false,
        editorType: 'dxSelectBox',
        
        nCol: 10,
        colSpan:3,
        lista: {
          dataSource: 'TipoAutomezzo',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          static: false,
          showDropDownButton: true
        }
      },
      
      
      {
        orderGriglia: 10,
        type: 'campoData',
        showInColumnChooser: true, allowHiding: false,
        colVisible: true,
        dataField: "dataInizio",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        nCol:5,
        caption: "Data iscrizione",

      },
      {
        type: 'empty',
        nCol:3,
        
      },
      {
        orderGriglia: 11,
        type: 'campoData',
        colVisible: true,
        showInColumnChooser: true, allowHiding: false,
        dataField: "dataFine",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date",
        caption: "Data cessaz.",
        nCol:5,
      },
     

      {
        orderGriglia: 7,

        showInColumnChooser: true, allowHiding: false,
        showEditorAlways: false,
        trueText: 'Si',
        falseText: 'No',
        type: 'campoSpecial',
        colVisible: true,
        labelWidth: 92,
        dataField: 'isScarrabile', dataType: "boolean", editorType: 'dxCheckBox', caption: 'Scarrabile', hideOnEdit: false,
        nCol:3,
        colSpan:3
        
      },
      

      
      {
        orderGriglia: 8,
        type: 'campo',
        colVisible: true,
        showInColumnChooser: true, allowHiding: false,
        dataField: 'isAutorizzatoADR',
        dataType: "boolean",
        editorType: 'dxCheckBox',
        caption: 'Aut. ADR',
        hideOnEdit: false,
        showEditorAlways: false,
        trueText: 'Autoriz.',
        falseText: 'Non autoriz.',
        nCol:3,
        colSpan:3
      },
      
      
      {
        showInColumnChooser: false,
        orderGriglia: 9,
        type: 'campo',
        colVisible: false,
        dataField: 'isSospeso',
        dataType: "boolean",
        editorType: 'dxCheckBox',
        caption: 'Sospeso',
        hideOnEdit: false,
        nCol:3,
        colSpan:3

      },



    ]
  },
]